import { FC } from "react";
import { useTranslation } from "react-i18next";

import { LoadingGroup, Panel } from "capitalrx-components-2.0/lib/general";
import { Grid, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Heading } from "capitalrx-components-2.0/lib/typography";

import { FindBestPriceDetailSection } from "./DetailSection";

const TRANSLATION_PATH = "PRICING_DETAIL_PANELS.drugDetails";

interface DrugDetailsProps {
  quantity: string;
  drugName: string;
  daysSupply: string | number;
  dosage: string;
  dosageForm: string;
  drugType: "Brand" | "Generic";
  isLoading: boolean;
}

export const DrugDetails: FC<DrugDetailsProps> = ({ quantity, drugName, daysSupply, dosage, dosageForm, drugType, isLoading }) => {
  const { t: translate } = useTranslation();

  const { columns } = useResponsive({
    columns: {
      desktop: 6,
      tablet: 6,
      mobile: 12,
    },
  });

  return (
    <LoadingGroup loading={isLoading}>
      <Stack>
        <Heading>{translate(`${TRANSLATION_PATH}.prescriptionDetails`)}</Heading>
        <Panel appearance="primary" className="member-portal-panel">
          <Grid>
            <Grid.Span columns={columns}>
              <FindBestPriceDetailSection
                title={translate(`${TRANSLATION_PATH}.name`)}
                content={drugName}
              />
            </Grid.Span>
            <Grid.Span columns={columns}>
              <FindBestPriceDetailSection
                title={translate(`${TRANSLATION_PATH}.type`)}
                content={translate(`${TRANSLATION_PATH}.drugType_${drugType}`, { defaultValue: drugType })}
              />
            </Grid.Span>
            <Grid.Span columns={columns}>
              <FindBestPriceDetailSection
                title={translate(`${TRANSLATION_PATH}.quantity`)}
                content={quantity}
              />
            </Grid.Span>
            <Grid.Span columns={columns}>
              <FindBestPriceDetailSection
                title={translate(`${TRANSLATION_PATH}.daysSupply`)}
                content={`${daysSupply} ${translate(`${TRANSLATION_PATH}.days`, { count: +daysSupply })}`}
              />
            </Grid.Span>
            <Grid.Span columns={columns}>
              <FindBestPriceDetailSection
                title={translate(`${TRANSLATION_PATH}.dosage`)}
                content={dosage}
              />
            </Grid.Span>
            <Grid.Span columns={columns}>
              <FindBestPriceDetailSection
                title={translate(`${TRANSLATION_PATH}.form`)}
                content={dosageForm}
              />
            </Grid.Span>
          </Grid>
        </Panel>
      </Stack>
    </LoadingGroup>
  );
};
